/* eslint-disable import/prefer-default-export */

export const CALENDAR_EVENT_CHANGED = 'CALENDAR_EVENT_CHANGED';
export const PERFORMERS_CHANGED = 'PERFORMERS_CHANGED';
export const SELECTED_PERFORMER_CHANGED = 'SELECTED_PERFORMER_CHANGED';
